import { listParagraphPlugin } from './plugin'

export const initListParagraphPlugin = () => {
  if (CKEDITOR.plugins.get('listparagraph')) {
    return
  }

  CKEDITOR.plugins.add('listparagraph', listParagraphPlugin)
}
